/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { Form } from 'app/components/ui/form';
import Title from '../form/title';
import Editor from '../form/editor';
import PageAttributes from '../form/page-attributes';
import Status from '../form/status';
import Categories from '../form/categories';
import Tags from '../form/tags';
import { Button } from 'app/components/ui/button';
import Excerpt from '../form/excerpt';
import { useBlogsSlice } from '../../slice';
import { useNavigate } from 'react-router-dom';
import FeaturedImage from '../form/featured-inage';
import { useToast } from 'app/components/ui/use-toast';

function AddBlogs() {
  const form = useForm({
    defaultValues: {
      status: 'published',
    },
  });
  const { toast } = useToast();

  const { useAddBlogsMutation } = useBlogsSlice();
  const [addBlogs, { data, isLoading, error }] = useAddBlogsMutation();

  const handleSubmit = () => {
    addBlogs(form.getValues());
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      toast({
        title: 'Blog added successfully',
        variant: 'success',
      });
      navigate('/blogs');
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      toast({
        title: 'Blog added failed',
        variant: 'destructive',
      });
    }
  }, [error]);

  return (
    <>
      <div className="flex justify-between items-center mb-1">
        <h1>Add New Blog</h1>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Saving' : 'Published'}{' '}
        </Button>
      </div>
      <div className="bg-gray-50 p-5 rounded-md shadow-sm blogs">
        <Form {...form}>
          <form>
            <div className="grid grid-cols-12 gap-6 ">
              <div className="col-span-9 bg-white  dark:bg-transparent p-5 rounded-md space-y-4">
                <Title />
                <Editor />
                <Excerpt />
              </div>

              <div className="col-span-3 space-y-4">
                <Status />
                <Categories />
                <Tags />
                <FeaturedImage />

                {/* <PageAttributes /> */}
              </div>
            </div>
          </form>
        </Form>
      </div>
    </>
  );
}
export default AddBlogs;
